import Skeleton from "react-loading-skeleton";
import 'react-loading-skeleton/dist/skeleton.css';

const MetricCardSkeleton = () => (
    <div className="m-2 w-full">
        <div className="flex flex-col items-start w-full">
            {/* Value */}
            <Skeleton height={36} width={80}/>
               
            {/* Name and metadata icon */}
            <div className="flex items-center my-1 w-full">
                <Skeleton height={14} width={80}/>
                <div className="ml-2 mb-4">
                    <Skeleton circle height={15} width={15}/>
                </div>
            </div>

        </div>
    </div>
);

export default MetricCardSkeleton;